import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldAlert } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const ImpersonationBanner = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [active] = useState(() => sessionStorage.getItem('impersonation_active') === '1');
  const name = sessionStorage.getItem('impersonation_name') || 'aday';

  if (!active) return null;

  const handleExit = () => {
    logout();
    sessionStorage.removeItem('impersonation_active');
    sessionStorage.removeItem('impersonation_name');
    navigate('/', { replace: true });
  };

  return (
    <div
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 1000,
        background: '#B45309',
        color: '#fff',
        fontSize: '13px',
        fontWeight: 600,
        padding: '8px 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '10px',
        flexWrap: 'wrap',
      }}
    >
      <ShieldAlert size={15} />
      <span>Admin görünümü: {name} olarak görüntüleniyorsunuz</span>
      <button
        type="button"
        onClick={handleExit}
        style={{
          background: 'rgba(255,255,255,0.15)',
          border: 'none',
          color: '#fff',
          fontSize: '12px',
          fontWeight: 700,
          padding: '4px 12px',
          borderRadius: '999px',
          cursor: 'pointer',
        }}
      >
        Çıkış
      </button>
    </div>
  );
};

export default ImpersonationBanner;
